/**
 * @module apis
 *
 * @description
 * The definitions of the WhatsApp Cloud API methods
 * that are implemented by the {@link WhatsAppAPI} class.
 */

export * as Message from "./message.js";
export * as Call from "./call.js";
export * as QR from "./qr.js";
export * as Media from "./media.js";
export * as Block from "./block.js";
export * as Webhook from "./webhook.js";
